export const verifyResetToken = {
  invalid: {
    alert: 'This reset link is invalid or has expired',
    cta: 'Return to sign in',
  },
  pending: 'Verifying reset token, you should be redirected shortly.',
};
